import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, EMPTY, from, switchMap, throwError } from 'rxjs';

import { AuthStore } from '../storage/auth';
import { isSessionExpiredResponse, SessionExpiryService } from '../session';

export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  const sessionExpiry = inject(SessionExpiryService);
  const hadSession = authStore.isAuthenticated();

  return next(req).pipe(
    catchError(error => {
      if (!hadSession || !isSessionExpiredResponse(error, req.url)) {
        return throwError(() => error);
      }

      // Completing empty on purpose: the user is on their way to the login
      // screen, so no caller downstream should surface an error for this call.
      return from(sessionExpiry.handleExpiredSession()).pipe(switchMap(() => EMPTY));
    })
  );
};
